<template>

    <div v-for="(item, index) in BankAccount" :key="index" class="mt-3">

        <div class="row">
            <div class="col-md-8 col-lg-6">

                <ui-input-box-floating class="mb-3" :error="getError(index, 'BankAccountNumber')">
                    <ui-input v-model="item.BankAccountNumber" type="text" placeholder="Расчетный счет"
                        :disabled="disabled" />
                    <ui-input-label>Расчетный счет</ui-input-label>
                </ui-input-box-floating>

                <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'BankAccountName')">
                    <ui-input v-model="item.BankAccountName" type="text" placeholder="Наименование банка"
                        :disabled="disabled" />
                    <ui-input-label>Наименование банка</ui-input-label>
                </ui-input-box-floating> -->

                <Autocomplete class="mb-3" v-model="item.BankAccountName" type="bank" label="Наименование банка"
                    placeholder="Наименование банка" :error="getError(index, 'BankAccountName')" :disabled="disabled"
                    @select="(d) => {
                        item.BankAccountName = d.value || ''
                        item.BankAccountCode = d?.data.bic || ''
                    }" />

                <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'BankAccountCode')">
                    <ui-input v-model="item.BankAccountCode" type="text" placeholder="БИК" :disabled="disabled" />
                    <ui-input-label>БИК</ui-input-label>
                </ui-input-box-floating> -->

                <Autocomplete class="mb-3" v-model="item.BankAccountCode" type="bank" label="БИК" placeholder="БИК"
                    :error="getError(index, 'BankAccountCode')" :disabled="disabled" @select="(d) => {
                        item.BankAccountName = d.value || ''
                        item.BankAccountCode = d?.data.bic || ''
                    }" />
            </div>

        </div>

        <button @click="() => del(index)" class="btn btn-ghost btn-small mb-2"
            :disabled="BankAccount.length == 1 || disabled">Удалить информацию о счете</button>
    </div>

    <button @click="add" class="btn btn-base btn-small" :disabled="disabled">Добавить информацию о счете</button>
</template>


<script setup>

import { ref, onMounted, watch } from 'vue'

import Autocomplete from "../../../component/Autocomplete/index.vue";

const props = defineProps({
    data: {
        type: Object,
        default: {}
    },
    errors: {
        type: Object,
        default: {}
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const BankAccount = ref([])

const add = () => {
    BankAccount.value = [...BankAccount.value, {}]
}

const del = (index) => {
    BankAccount.value = BankAccount.value.filter((item, itemIndex) => itemIndex !== index)
}

const getError = (index, field) =>
    props.errors?.BankAccount?.[index]?.[field] || false

onMounted(async () => {

    const isValidObjectArray = Array.isArray(props.data?.BankAccount) && props.data.BankAccount.every(item => typeof item === 'object' && !Array.isArray(item))

    BankAccount.value = isValidObjectArray ? props.data.BankAccount : [{}]

})

watch(BankAccount, (newValue) => {

    props.data.BankAccount = newValue

}, { deep: true })

</script>